import React, { Fragment, useContext } from 'react'
import {Button, Dropdown, DropdownItem, DropdownMenu, Icon, Menu} from 'semantic-ui-react'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from '../../../App/stores/RootStore'
import { IRequest } from '../../../App/models/Request';
import Continue from './Options/Continue';
import Create from './Options/Create';
import Deny from './Options/Deny';
import RoleRules from '../../../App/enumerable/RolesRules';
import Unlock from './Options/Unlock';
import ReSend from "./Options/ReSend";

interface Params {
    request: IRequest;
};

const RequestControl: React.FC<Params> = (Request) => {
    const rootStore = useContext(RootStoreContext)
    const { user, HasRoles } = rootStore.userStore;

    const { openModal } = rootStore.modalStore;

    const { request } = Request;
    const RoleValidation = () => {
        if (request?.status == "Pending Recommendation") {
            return HasRoles(RoleRules.FirstReviewer) ||
                HasRoles(RoleRules.SecondReviewer) ||
                HasRoles(RoleRules.ThirdReviewer) ||
                HasRoles(RoleRules.ReviewerAdmin);
        }
        else if (request?.status == "Pending Decision") {
            return HasRoles(RoleRules.SecondReviewer) ||
                HasRoles(RoleRules.ThirdReviewer) ||
                HasRoles(RoleRules.ReviewerAdmin);
        }
        else if (request?.status == "Pending Additional Review") {
            return HasRoles(RoleRules.ThirdReviewer) ||
                HasRoles(RoleRules.ReviewerAdmin);
        }

    }

    if (request?.status == "Review Closed") {
        if(HasRoles(RoleRules.ReviewerAdmin)){
            return (
                    <Dropdown  className='icon' item icon={'ellipsis vertical'} >
                        <DropdownMenu  >
                            <DropdownItem>
                                <Button
                                    color='grey'
                                    disabled={true}
                                >
                                    Review Closed
                                    <Icon name="arrow alternate circle right" />
                                </Button>
                            </DropdownItem>
                            <DropdownItem>
                                <Button
                                    className={'rl-btn'}
                                    onClick={() => openModal(<ReSend requestId={request.id} />)} >
                                    reSend to TRD
                                    <Icon name="arrow alternate circle right" />
                                </Button>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
            )
        }
        else{
            return (
                    <Dropdown className='icon' item icon={'ellipsis vertical'}>
                        <DropdownMenu>
                            <DropdownItem>
                                <Button
                                    color='grey'
                                    disabled={true}
                                >
                                    Review Closed
                                    <Icon name="arrow alternate circle right" />
                                </Button>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                // </Menu>

            )
        }

    }

    else if (request?.currentRequestReviewId && request?.currentRequestReviewerId == user?.id) {
        return (
                <Dropdown className='icon' item icon={'ellipsis vertical'}>
                    <DropdownMenu>
                        <DropdownItem>
                            <Button
                                className={'rl-btn'}
                                onClick={() => openModal(<Unlock requestId={request.id} requestReviewId={request.currentRequestReviewId ?? ""} />)}
                                icon='unlock alternate'
                                content="Unlock Review "
                            >
                            </Button>
                        </DropdownItem>
                        <DropdownItem>
                            <Button
                                className={'rl-btn'}
                                onClick={() => openModal(<Continue RequestReviewId={request.currentRequestReviewId ?? ""} />)} >
                                Continue Review
                                <Icon name="arrow alternate circle right" />
                            </Button>
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>


        )
    }
    else if (!request?.currentRequestReviewId) {

        if (request?.prevReviewers.includes(user!.id) || !RoleValidation()) {
            return (

                <Dropdown className='icon' item icon={'ellipsis vertical'}>
                        <DropdownMenu>
                            <DropdownItem>
                                <Button
                                    color='grey'
                                    onClick={() => openModal(<Deny />)} >
                                    Cannot Start Review
                                    <Icon name="cancel" />

                                </Button>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>

            )
        }
        else {
            return (
                <Dropdown className='icon' item icon={'ellipsis vertical'}>
                        <DropdownMenu>
                            <DropdownItem>
                                <Button
                                    positive
                                    onClick={() => openModal(<Create id={request.id} />)} >
                                    Start Review
                                    <Icon name="arrow alternate circle right" />
                                </Button>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>

            )
        }

    }
    else {
        if (HasRoles(RoleRules.ReviewerAdmin)) {
            return (
                <Dropdown className='icon' item icon={'ellipsis vertical'}>
                        <DropdownMenu>
                            <DropdownItem>
                                <Button
                                    className={'rl-btn'}
                                    onClick={() => openModal(<Unlock requestId={request.id} requestReviewId={request.currentRequestReviewId ?? ""} />)}
                                    icon='unlock alternate'
                                    content="Unlock Review "
                                >
                                </Button>
                            </DropdownItem>
                            <DropdownItem>
                                <Button
                                    color='grey'
                                    disabled={true}
                                    onClick={() => openModal(<Deny />)}
                                    icon='cancel'
                                    content="Review In Progress "
                                >
                                </Button>
                        </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
            )
        }
        else {
            return (


                <Dropdown className='icon' item icon={'ellipsis vertical'}>
                        <DropdownMenu>
                            <DropdownItem>
                                <Button
                                    color='grey'
                                    disabled={true}
                                    onClick={() => openModal(<Deny />)} >
                                    Review In Progress
                                    <Icon name="cancel" />

                                </Button>
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>

            )
        }

    }
}
export default observer(RequestControl);